import {dictionary_en} from './dictionary_en';
import {dictionary_fr} from './dictionary_fr';

let dictionary;
try {
    dictionary = (window.navigator.languages && window.navigator.languages[0] || window.navigator.language || window.navigator.userLanguage).includes('fr') ? dictionary_fr : dictionary_en;
} catch (err) {
    dictionary = dictionary_en;
}

export function translate(text) {

    const translation = dictionary[text];
    if (translation)
        return translation;
    // Use in order to check if text exists in dictionary
    //return "*".repeat(text.length);
	return text;
}


// WEBPACK FOOTER //
// ./src/i18n/translate.js